import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { ItineraryProps } from "../../../../types/screensTypes";
import { FileInput } from "../../../../components/common/FileInput";
import TitleSubtitle from "../../../../components/common/TitleSubtitle";
import { useTrackCreation } from "../../../../context/TrackCreationContext";
import { uploadFileToS3Complete } from "../../../../api/s3";
import Button from "../../../../components/ui/Button";
import stepStyles from "../createStep.module.css";

const Itinerary: React.FC<ItineraryProps> = ({ navigateToNext }) => {
    const { trackData, updateTrackData, generateWaypointsFromExcel } = useTrackCreation();
    const [path, setPath] = useState<string>("");
    const [isAILoading, setIsAILoading] = useState<boolean>(false);
    const isAILoadingRef = useRef<boolean>(isAILoading);
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    // Sync the ref with the latest loading state
    useEffect(() => {
        isAILoadingRef.current = isAILoading;
    }, [isAILoading]);

    const handleFileSelected = (files: File | File[]) => {
        const file = Array.isArray(files) ? files[0] : files; // Toujours prendre un seul fichier

        if (file) {
            const token = localStorage.getItem("token");
            if (!token) {
                console.error("No authentication token found");
                return;
            }

            uploadFileToS3Complete(
                {
                    file,
                    isPublic: true, // Public files for general uploads
                    isFolder: false, // No folder structure for general uploads
                },
                token,
            )
                .then((result: string) => {
                    setPath(result);
                    updateTrackData("excelPath", result);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    const clickDownloadSample = async (): Promise<void> => {
        window.open("https://rewindstories.s3.eu-west-3.amazonaws.com/templateTrack.xlsx", "_blank");
    };

    const handleGenerateTour = async (): Promise<void> => {
        setIsAILoading(true); // User initiated generation
        const trackId = trackData.trackId;
        if (!trackId) return;
        await generateWaypointsFromExcel(path, trackId);
        await new Promise((resolve) => setTimeout(resolve, 2000));
        setIsAILoading(false); // Manual generation completed
        updateTrackData("hasExcelGenerated", true);
        navigateToNext();
    };

    return (
        <div className={`step-container ${stepStyles.stepContainer} ${stepStyles.step}`}>
            <TitleSubtitle title={t("yourItinerary")} subtitle={t("youCanChooseWhetherOrNotToFill")} layout="step" />

            <div style={{ marginTop: "20px" }}>
                <Button label={t("downloadSample")} className="download-button" onClick={clickDownloadSample} />
            </div>

            <div style={{ marginTop: "20px" }}>
                <FileInput onFileSelected={handleFileSelected} placeholder={t("dropYourExcelFileInTheSameFormat")} />
            </div>

            <div className={`${stepStyles.stepButton} ${stepStyles.footer}`}>
                <Button
                    label={isAILoading ? t("generating") : t("generateMyTour")}
                    onClick={() => handleGenerateTour()}
                    variant="primary"
                    shape="pill"
                    className={stepStyles.continueBtn}
                    disabled={isAILoading}
                />
            </div>

            <div className={stepStyles.stepWarning}>
                <h2>{t("tourCanBeOnyGeneratedOnce")}</h2>
                <p style={{ textAlign: "justify" }}>{t("tourCanBeOnyGeneratedOnceDescription")}</p>
            </div>
        </div>
    );
};

export default Itinerary;
